export const COOKIE_WELCOME_SELLER_NAME = 'BmCGUModalLastShown'

export const MINUTES_COUNTER_WITHOUT_MODAL_IN_MS = 60 * 24 * 15 * 60000

export const REGISTERED_PARAM_VALUE = 'OK'

export const MODAL_NAMES = {
  WELCOME_SELLER: 'WELCOME_SELLER',
}
